import React from 'react'
import { Stack, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

import { Dialog } from '@e3dc-react/shell/Elements/Dialog'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { InformationTile } from '../common'

export interface Props {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  primaryActionText: string
  title: string
  description: string
  infoMessage?: string
}

const useStyles = makeStyles()(theme => ({
  content: {
    [theme.breakpoints.down('sm')]: {
      marginTop: 0,
      marginBottom: 0,
    },
  },
}))

/**
 * Dialog component to inform that user is about to change important setting and should confirm this action.
 */
const ConfirmSettingChangeDialog: React.FC<Props> = ({ onClose, isOpen, onConfirm, primaryActionText, title, description, infoMessage }) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()

  const modalActions = {
    primary: {
      name: primaryActionText,
      onClick: onConfirm,
    },
    secondary: { name: t('common.cancel'), onClick: onClose },
  }

  return (
    <Dialog maxWidth="sm" title={title} actions={modalActions} onClose={onClose} contentClassName={classes.content}>
      <Stack mt={4} gap={2} mb={4}>
        <Typography variant="body2">{description}</Typography>
        {infoMessage && <InformationTile message={infoMessage} />}
      </Stack>
    </Dialog>
  )
}

export default ConfirmSettingChangeDialog
